import api from '@/lib/api';
import type {
  ApiResponse,
  MessagingConversationView,
  MessagingMessageView,
  MessagingCreateConversationRequest,
  MessagingSendMessageRequest,
  MessagingUnreadCountResponse,
} from '@amuster/types';

export interface ListConversationsParams {
  cursor?: string;
  limit?: number;
}

export interface ListMessagesParams {
  cursor?: string;
  limit?: number;
}

export const messagingService = {
  // ── Conversations ─────────────────────────────────────────────────────────

  listConversations(params?: ListConversationsParams) {
    return api.get<
      ApiResponse<MessagingConversationView[]> & { meta: { next_cursor: string | null } }
    >('/messaging/conversations', { params });
  },

  createConversation(data: MessagingCreateConversationRequest) {
    return api.post<ApiResponse<MessagingConversationView>>(
      '/messaging/conversations',
      data,
    );
  },

  // ── Messages ──────────────────────────────────────────────────────────────

  listMessages(conversationId: string, params?: ListMessagesParams) {
    return api.get<
      ApiResponse<MessagingMessageView[]> & { meta: { next_cursor: string | null } }
    >(`/messaging/conversations/${conversationId}/messages`, { params });
  },

  sendMessage(conversationId: string, data: MessagingSendMessageRequest) {
    return api.post<ApiResponse<MessagingMessageView>>(
      `/messaging/conversations/${conversationId}/messages`,
      data,
    );
  },

  markRead(conversationId: string) {
    return api.post<ApiResponse<{ marked_read: boolean }>>(
      `/messaging/conversations/${conversationId}/read`,
    );
  },

  // ── Unread Count ──────────────────────────────────────────────────────────

  getUnreadCount() {
    return api.get<ApiResponse<MessagingUnreadCountResponse>>(
      '/messaging/unread-count',
    );
  },

  // ── User Search ───────────────────────────────────────────────────────────

  searchUsers(q: string, limit?: number) {
    return api.get<
      ApiResponse<
        Array<{
          id: string;
          name_en: string;
          name_ar: string | null;
          photo_url: string | null;
          department: string | null;
          role: string;
        }>
      >
    >('/messaging/users/search', { params: { q, limit } });
  },
};
